export function filterCascader(node, keyword) {
    const re = new RegExp(keyword, 'i')
    return node.text.match(re);
}